/**
 * GTD Domain Errors following clean error handling patterns
 */
export class GTDDomainError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly context?: Record<string, any>
  ) {
    super(message);
    this.name = 'GTDDomainError';
  }
}

export class ThoughtProcessingError extends GTDDomainError {
  constructor(message: string, context?: Record<string, any>) {
    super(message, 'THOUGHT_PROCESSING_ERROR', context);
    this.name = 'ThoughtProcessingError';
  }
}

export class InvalidProcessingStatusError extends GTDDomainError {
  constructor(currentStatus: string, requiredStatus: string) {
    super(
      `Cannot perform this operation. Current status: ${currentStatus}, required: ${requiredStatus}`,
      'INVALID_PROCESSING_STATUS',
      { currentStatus, requiredStatus }
    );
    this.name = 'InvalidProcessingStatusError';
  }
}

export class InvalidActionDurationError extends GTDDomainError {
  constructor(duration: number) {
    super(
      `Action duration exceeds reasonable bounds. Duration: ${duration} minutes. Maximum allowed: 480 minutes (8 hours).`,
      'INVALID_ACTION_DURATION',
      { duration, maxDuration: 480 }
    );
    this.name = 'InvalidActionDurationError';
  }
}

export class ProjectStateError extends GTDDomainError {
  constructor(message: string, projectId: string, currentState: string) {
    super(message, 'PROJECT_STATE_ERROR', { projectId, currentState });
    this.name = 'ProjectStateError';
  }
}

export class AssignmentError extends GTDDomainError {
  constructor(message: string, actionId: string) {
    super(message, 'ASSIGNMENT_ERROR', { actionId });
    this.name = 'AssignmentError';
  }
}